import axios from "../../apis/Api";
import history, { logout } from "../../history";
import { toast } from "react-toastify";
import {
  GET_VFOVISIT_FORM_LIST,
  REMOVE_VFOVISIT_DETAIL_LIST,
} from "../../Types";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const GetVFOVisitListForm = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/VizShopCheckIn/GetVFOVisitListForm`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_VFOVISIT_FORM_LIST,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};
export const RemoveVFOVisitListDetail = () => async (dispatch) => {
  dispatch({
    type: REMOVE_VFOVISIT_DETAIL_LIST,
    payload: [],
  });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/VizShopCheckIn/GetDownloadVFOVisit`, requestData)
    .then(({ data }) => {
      // ;
      const outputFilename = `VFO_VISIT_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "_1_DistributorName"
                ? "Distributor"
                : ws[address].v == "_2_DistCntrName"
                  ? "Dist Center"
                  : ws[address].v == "_3_GetVisitDateTime"
                    ? "Date & Time "
                    : ws[address].v == "_4_VfoName"
                      ? "VFO Name"
                      : ws[address].v == "_5_VizId"
                        ? "VIZ-ID"
                        : ws[address].v == "_6_ShopCode"
                          ? "Shop Code"
                          : ws[address].v == "_7_ShopName"
                            ? "Shop Name"
                            : ws[address].v == "_8_Cnic"
                              ? "CNIC No"
                              : ws[address].v == "_9_Address"
                                ? "Address"
                                : ws[address].v == "_10_Remarks"
                                  ? "Remarks"
                                  : ws[address].v == "_11_ShopLat"
                                    ? "Shop Lat"
                                    : ws[address].v == "_12_VisitedLat"
                                      ? "Visited Lat"
                                      : ws[address].v == "_13_ShopLong"
                                        ? "Shop Long"
                                        : ws[address].v == "_14_VisitedLong"
                                          ? "Visited Long"
                                          : ws[address].v == "_15_GetStatus"
                                            ? "Status"
                                            : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.response, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
